import React, { useRef, useEffect, useState } from 'react'
import SwiperCore, { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useTrans } from 'hooks'
import { mockArray, mockFaq } from 'utils/mock'
import { useCategorieFaqQuery } from 'gql/graphql'
import {
  FaqProdotti,
  FaqPagamenti,
  FaqSpedizioniResi,
  FaqAssistenza,
  FaqAccount,
  FaqGenerali,
} from 'components/atoms/Icons'
import { FaqCategoryCard, ContattiBox } from 'components/molecules'
import { Page, FaqCategoryDetail } from 'components/organisms'

SwiperCore.use([Pagination])

interface Props {
  pagina?: any
}

const FaqTemplate = (props: Props) => {
  const { pagina = null } = props
  const [jsonLd, setJsonLd] = useState(null)
  const t = useTrans()
  const categoriesRefs = useRef({})
  const { data: dataCategorieFaq } = useCategorieFaqQuery()
  const [categorieFaq, setCategorieFaq] = useState([])

  const icons = [
    { chiave: 'prodotti', icon: <FaqProdotti /> },
    { chiave: 'pagamenti', icon: <FaqPagamenti /> },
    { chiave: 'spedizioni-resi', icon: <FaqSpedizioniResi /> },
    { chiave: 'assistenza', icon: <FaqAssistenza /> },
    { chiave: 'account', icon: <FaqAccount /> },
    { chiave: 'generali', icon: <FaqGenerali /> },
  ]

  const goToFaqCategory = (id) => {
    if (categoriesRefs.current?.[id]) {
      const headerHeight = document.getElementsByClassName('header')[0].clientHeight
      window.scrollTo({
        top: categoriesRefs.current[id].offsetTop - headerHeight - 20, // header fixed + 20 px di margine
        behavior: 'smooth',
      })
    }
  }

  function getIcon(chiave) {
    const iconItem = icons.find((icon) => icon.chiave === chiave)
    return iconItem ? iconItem.icon : null
  }

  useEffect(() => {
    if (dataCategorieFaq?.categorieFaq) {
      setCategorieFaq(
        dataCategorieFaq.categorieFaq.edges.map(({ node }) => ({
          id: node.pk,
          icon: getIcon(node.chiave),
          nome: node.nome,
          faqs: node.faq.map((faq) => ({
            id: faq.pk,
            nome: faq.nome,
            descrizione: faq.descrizione,
          })),
        }))
      )
    }
  }, [dataCategorieFaq])

  useEffect(() => {
    if (categorieFaq.length > 0 && !jsonLd) {
      let mainEntity = []
      categorieFaq.map((cat) => {
        cat.faqs.map((faq) => {
          mainEntity.push({
            '@type': 'Question',
            'name': faq.nome,
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': faq.descrizione,
            },
          })
        })
      })
      const updatedJsonLd = {
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        'mainEntity': mainEntity,
      }
      setJsonLd(updatedJsonLd)
    }
  }, [categorieFaq, jsonLd])

  useEffect(() => {
    if (jsonLd !== null) {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.innerHTML = JSON.stringify(jsonLd)
      document.head.appendChild(script)
      return () => {
        document.head.removeChild(script)
      }
    }
  }, [jsonLd])

  return (
    <Page pagina={pagina} topBg="center" className="faq-template">
      <div className="faq-template__cards-list faq-template__cards-list--desktop">
        {categorieFaq.map((cat) => (
          <div className="faq-template__cards-item" key={`faq-template__cards__item__${cat.id}`}>
            <FaqCategoryCard
              title={cat.nome}
              icon={cat.icon}
              onClick={() => goToFaqCategory(cat.id)}
            />
          </div>
        ))}
      </div>
      <div className="faq-template__cards-list faq-template__cards-list--mobile">
        <Swiper spaceBetween={20} slidesPerView={1} pagination={{ clickable: true }}>
          {categorieFaq.map((cat) => (
            <SwiperSlide key={`faq-template__cards__item__${cat.id}`}>
              <FaqCategoryCard
                title={cat.nome}
                icon={cat.icon}
                onClick={() => goToFaqCategory(cat.id)}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="faq-template__details-list">
        {categorieFaq.map((cat) => (
          <div
            ref={(element) => (categoriesRefs.current[cat.id] = element)}
            key={`faq-template__details__item__${cat.id}`}
          >
            <FaqCategoryDetail faqCategory={cat} />
          </div>
        ))}
      </div>
      <ContattiBox
        title={t('Non hai trovato le risposte che cercavi?')}
        description={t(
          'Scrivici sul nostro form di contatto. Riceverai una risposta dalla nostra assistenza clienti entro 48h.'
        )}
        button={{
          label: t('Contattaci'),
          href: '/contattaci',
        }}
        className="faq-template__contatti-box"
      />
    </Page>
  )
}

export default FaqTemplate
